/* Gallery Performance Optimizer v1.0 */
/* Preloads adjacent images for instant mobile swipe transitions */
(function(){
  if(window.__galleryPerfLoaded)return;
  window.__galleryPerfLoaded=true;

  var PRELOAD_AHEAD=3;
  var MOBILE_WIDTH=600;
  var isMobile=window.innerWidth<768||"ontouchstart"in window;

  function getGalleryImgs(){
    return document.querySelectorAll(".ppu-gallery-main>img");
  }

  function getCurrentIdx(imgs){
    for(var i=0;i<imgs.length;i++){
      if(imgs[i].classList.contains("ppu-gallery-active"))return i;
    }
    return 0;
  }

  function downsizeSrc(src){
    if(!isMobile)return src;
    return src.replace(/width=(\d+)/,function(m,w){
      return parseInt(w)>MOBILE_WIDTH?"width="+MOBILE_WIDTH:m;
    });
  }

  function preloadImg(img){
    if(!img||img.dataset.ppuPreloaded)return;
    img.dataset.ppuPreloaded="1";
    if(isMobile){img.src=downsizeSrc(img.src);}
    img.loading="eager";
    if(!img.complete){
      var prefetch=new Image();
      prefetch.src=img.src;
    }
    if(img.decode){
      img.decode().catch(function(){});
    }
  }

  function preloadAround(idx,imgs){
    if(!imgs||!imgs.length)return;
    var total=imgs.length;
    for(var d=1;d<=PRELOAD_AHEAD;d++){
      if(idx+d<total)preloadImg(imgs[idx+d]);
      if(idx-d>=0)preloadImg(imgs[idx-d]);
    }
  }

  function init(){
    var imgs=getGalleryImgs();
    if(!imgs.length)return false;

    var cur=getCurrentIdx(imgs);

    /* Downsize current image on mobile too */
    if(isMobile&&imgs[cur]){
      imgs[cur].src=downsizeSrc(imgs[cur].src);
    }

    /* Preload images around current */
    preloadAround(cur,imgs);

    /* Observe class changes to detect slide switches */
    var observer=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var m=muts[i];
        if(m.type==="attributes"&&m.attributeName==="class"){
          var el=m.target;
          if(el.tagName==="IMG"&&el.classList.contains("ppu-gallery-active")){
            var allImgs=getGalleryImgs();
            var newIdx=getCurrentIdx(allImgs);
            preloadAround(newIdx,allImgs);
          }
        }
      }
    });

    var main=document.querySelector(".ppu-gallery-main");
    if(main){
      observer.observe(main,{attributes:true,attributeFilter:["class"],subtree:true});
    }

    return true;
  }

  /* Try init immediately, retry if gallery not ready */
  if(!init()){
    var tries=0;
    var iv=setInterval(function(){
      if(init()||++tries>30)clearInterval(iv);
    },200);
  }

  /* Also handle v2-gallery (desktop) */
  function initV2(){
    var v2imgs=document.querySelectorAll(".v2-gallery-main img");
    if(!v2imgs.length)return;
    for(var i=0;i<Math.min(v2imgs.length,3);i++){
      if(v2imgs[i].loading==="lazy")v2imgs[i].loading="eager";
      if(!v2imgs[i].complete){
        var pf=new Image();pf.src=v2imgs[i].src;
      }
      if(v2imgs[i].decode)v2imgs[i].decode().catch(function(){});
    }
  }
  setTimeout(initV2,500);

})();